import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useStickyAutoScroll } from '@/hooks/useStickyAutoScroll';
import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';

import Dialog from './Dialog';
import EmptyState from './EmptyState';
import ScrollToBottom from './ScrollToBottom';

import s from './DialogItems.module.scss';

type DialogItemsProps = {
  isDrawer?: boolean;
  /** В drawer над конкретным документом — ограниченный контекст одним файлом */
  drawerFixedDocumentId?: string;
};

const DialogItems: React.FC<DialogItemsProps> = ({ isDrawer = false, drawerFixedDocumentId }) => {
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const { isNewSession, messages, meta } = useOrganizationChatAiPageStore();

  const lastTextLength = messages.at(-1)?.text?.length ?? 0;

  const { bottomRef, isNearBottom, scrollNow } = useStickyAutoScroll({
    containerRef,
    deps: [messages.length, meta.isLoading, lastTextLength],
    threshold: 80,
    scrollOnMount: true,
    behavior: 'smooth',
    block: 'end',
  });

  if (isNewSession) {
    return <EmptyState className={s.root__empty} isDrawer={isDrawer} drawerFixedDocumentId={drawerFixedDocumentId} />;
  }

  return (
    <div className={s.root}>
      <div className={s.root__scroll} ref={containerRef} data-scroll-lock-allow>
        <Dialog bottomRef={bottomRef} />
      </div>
      {!isNearBottom && <ScrollToBottom onClick={scrollNow} className={s['root__scroll-to-bottom']} />}
    </div>
  );
};

export default observer(DialogItems);
